import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import { DialogManager } from '../../dialogs_new/DialogManager';
import useDialogLauncher from '../../dialogs-routable/_hooks/useDialogLauncher';

MessageEvent.propTypes = {
  message: PropTypes.object.isRequired
};

export default function MessageEvent(props) {
  const { message } = props;

  const launch = useDialogLauncher();

  const event = useConnect('event.byId', {
    id: message.data.eventId
  }, {
    enabled: !!message.data.eventId
  });

  const activity = useConnect('tag.byId', {
    id: event.data.activityId
  }, {
    enabled: !!event.data.activityId
  });

  if (
    !message.data.eventId ||
    event.state === PayloadStates.FETCHING
  ) {
    return null;
  }

  function onClick() {
    launch(DialogManager.Event.Config(event.id));
  }

  return (
    <span>
      Related to <span className="text-cs-orange-500 cursor-pointer hover:text-cs-yellow-500" onClick={onClick}>{event.data.title || activity.data.name}</span> (Event)
    </span>
  );
}
